export default "__VITE_ASSET__DJeMvYnF__"